export type Lang = "ru" | "en";

const translations = {
  // Navigation
  "nav.dashboard": { ru: "Обзор", en: "Dashboard" },
  "nav.pools": { ru: "Пулы", en: "Pools" },
  "nav.wallet": { ru: "Кошелёк", en: "Wallet" },
  "nav.referrals": { ru: "Рефералы", en: "Referrals" },
  "nav.profile": { ru: "Профиль", en: "Profile" },

  // Dashboard
  "dash.title": { ru: "Обзор", en: "Dashboard" },
  "dash.welcome": { ru: "Добро пожаловать", en: "Welcome back" },
  "dash.totalInvested": { ru: "Вложено", en: "Invested" },
  "dash.totalMined": { ru: "Намайнено GNK", en: "Mined GNK" },
  "dash.activePools": { ru: "Активные пулы", en: "Active Pools" },
  "dash.currentYield": { ru: "Доходность", en: "Current Yield" },
  "dash.recentActivity": { ru: "Последняя активность", en: "Recent Activity" },
  "dash.myPools": { ru: "Мои пулы", en: "My Pools" },
  "dash.perMonth": { ru: "/мес", en: "/mo" },

  // Pools
  "pools.title": { ru: "Пулы", en: "Mining Pools" },
  "pools.subtitle": { ru: "Объединяйте средства для майнинга GNK", en: "Pool resources to mine GNK together" },
  "pools.active": { ru: "Активные", en: "Active" },
  "pools.collecting": { ru: "Сбор средств", en: "Collecting" },
  "pools.completed": { ru: "Завершённые", en: "Completed" },
  "pools.all": { ru: "Все", en: "All" },
  "pools.participants": { ru: "участников", en: "participants" },
  "pools.target": { ru: "Цель", en: "Target" },
  "pools.collected": { ru: "Собрано", en: "Collected" },
  "pools.hashrate": { ru: "Хешрейт", en: "Hashrate" },
  "pools.yield": { ru: "Доходность", en: "Yield" },
  "pools.join": { ru: "Вступить", en: "Join Pool" },
  "pools.status.mining": { ru: "Майнинг", en: "Mining" },
  "pools.status.collecting": { ru: "Сбор", en: "Collecting" },
  "pools.status.completed": { ru: "Завершён", en: "Completed" },
  "pools.gpu": { ru: "Видеокарта", en: "GPU" },

  // Pool Detail
  "pool.details": { ru: "Детали пула", en: "Pool Details" },
  "pool.info": { ru: "Информация", en: "Information" },
  "pool.members": { ru: "Участники", en: "Members" },
  "pool.history": { ru: "История начислений", en: "Reward History" },
  "pool.deposit": { ru: "Внести средства", en: "Deposit Funds" },
  "pool.yourShare": { ru: "Ваша доля", en: "Your Share" },
  "pool.yourEarnings": { ru: "Ваш доход", en: "Your Earnings" },
  "pool.totalMined": { ru: "Всего намайнено", en: "Total Mined" },
  "pool.dailyReward": { ru: "Награда/день", en: "Daily Reward" },
  "pool.back": { ru: "Назад", en: "Back" },

  // Deposit
  "deposit.title": { ru: "Пополнение пула", en: "Pool Deposit" },
  "deposit.amount": { ru: "Сумма в рублях", en: "Amount in rubles" },
  "deposit.card": { ru: "Номер карты", en: "Card Number" },
  "deposit.expiry": { ru: "Срок", en: "Expiry" },
  "deposit.cvv": { ru: "CVV", en: "CVV" },
  "deposit.pay": { ru: "Оплатить", en: "Pay" },
  "deposit.min": { ru: "Мин. взнос", en: "Min. deposit" },
  "deposit.success": { ru: "Платёж успешно проведён!", en: "Payment successful!" },
  "deposit.remaining": { ru: "Осталось собрать", en: "Remaining to collect" },

  // Wallet
  "wallet.title": { ru: "Кошелёк", en: "Wallet" },
  "wallet.balance": { ru: "Баланс GNK", en: "GNK Balance" },
  "wallet.equivalent": { ru: "Эквивалент", en: "Equivalent" },
  "wallet.withdraw": { ru: "Вывести", en: "Withdraw" },
  "wallet.history": { ru: "История транзакций", en: "Transaction History" },
  "wallet.mining": { ru: "Майнинг", en: "Mining" },
  "wallet.withdrawal": { ru: "Вывод", en: "Withdrawal" },
  "wallet.bonus": { ru: "Бонус", en: "Bonus" },
  "wallet.address": { ru: "Адрес кошелька GNK", en: "GNK Wallet Address" },
  "wallet.withdrawAmount": { ru: "Сумма вывода", en: "Withdraw Amount" },
  "wallet.confirm": { ru: "Подтвердить вывод", en: "Confirm Withdrawal" },
  "wallet.pendingRewards": { ru: "Ожидаемые награды", en: "Pending Rewards" },
  "wallet.todayEarnings": { ru: "Заработано сегодня", en: "Today's Earnings" },

  // Referrals
  "ref.title": { ru: "Реферальная программа", en: "Referral Program" },
  "ref.subtitle": { ru: "Приглашайте друзей и получайте бонусы", en: "Invite friends and earn bonuses" },
  "ref.link": { ru: "Ваша ссылка", en: "Your Link" },
  "ref.copy": { ru: "Копировать", en: "Copy" },
  "ref.copied": { ru: "Скопировано!", en: "Copied!" },
  "ref.invited": { ru: "Приглашено", en: "Invited" },
  "ref.earned": { ru: "Заработано GNK", en: "Earned GNK" },
  "ref.bonus": { ru: "Бонус за реферала", en: "Referral Bonus" },
  "ref.friends": { ru: "Приглашённые друзья", en: "Invited Friends" },
  "ref.share": { ru: "Поделиться", en: "Share" },
  "ref.level": { ru: "Уровень", en: "Level" },

  // Profile
  "profile.title": { ru: "Профиль", en: "Profile" },
  "profile.settings": { ru: "Настройки", en: "Settings" },
  "profile.language": { ru: "Язык", en: "Language" },
  "profile.notifications": { ru: "Уведомления", en: "Notifications" },
  "profile.security": { ru: "Безопасность", en: "Security" },
  "profile.history": { ru: "История операций", en: "Transaction History" },
  "profile.logout": { ru: "Выйти", en: "Log out" },
  "profile.email": { ru: "Email", en: "Email" },
  "profile.name": { ru: "Имя", en: "Name" },
  "profile.memberSince": { ru: "Участник с", en: "Member since" },
  "profile.totalInvested": { ru: "Всего вложено", en: "Total invested" },
  "profile.save": { ru: "Сохранить", en: "Save" },
  "profile.twoFactor": { ru: "Двухфакторная аутентификация", en: "Two-factor authentication" },
  "profile.enabled": { ru: "Включена", en: "Enabled" },

  // Common
  "common.gnk": { ru: "GNK", en: "GNK" },
  "common.rub": { ru: "₽", en: "₽" },
  "common.loading": { ru: "Загрузка...", en: "Loading..." },
  "common.close": { ru: "Закрыть", en: "Close" },
  "common.cancel": { ru: "Отмена", en: "Cancel" },
} as const;

type TranslationKey = keyof typeof translations;

export function t(key: TranslationKey, lang: Lang): string {
  return translations[key]?.[lang] ?? key;
}

export function formatRub(amount: number): string {
  return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "RUB", maximumFractionDigits: 0 }).format(amount);
}

export function formatGNK(amount: number): string {
  return amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
